<template>
	<div class="markdown prose">
        <p class="text-black01 font-weight-bold">Upgrade your trading:</p>
        <p>1️⃣ <span class="text-black01 font-weight-bold">Autopilot (Next-Gen):</span> ERC-5173 automates fairness—no losses, just growth.</p>
        <ul class="ml-8 custom-ul">
            <li>Planetary: Take profits like Soros, automatically.</li>
            <li>Stellar: Dalio’s risk management, baked in.</li>
            <li>Galactic: Buffett’s patience, turbocharged.</li>
        </ul>
        <p>2️⃣ <span class="text-black01 font-weight-bold">Crypto Racetrack (Legacy):</span> Manual trading, emotional rollercoaster. (Spoiler: Institutions profit while you burn.)</p>
        <p>Autopilot’s your gateway to effortless success with ERC-5173’s shared prosperity, and you can take control manually anytime.</p>
        <p>🚨 Autopilot is invite-only. Secure your spot before the crowd.</p>
        <!-- 响应操作 -->
        <ResponseAction @updateResponse="$emit('updateResponse')"></ResponseAction>
        
        
        
        <!-- 发送的消息 -->
        <div id="ai-tradingTypeAnswer" v-if="tradingTypeAnswer != null" class="mt-6 d-flex r-justify-end">
            <v-card rounded="xl" elevation="0" class="pa-4 w-66 text-base" color="f3f3f3-303030">
                <div v-for="(answer, index) in answers" :key="`answer-index-${index}`">
                    <div v-if="answer.code == tradingTypeAnswer">{{ answer.message }}</div>
                </div>
            </v-card>
        </div>
        <!-- 消息框 -->
        <MessageBox v-else :messages="answers" @onSent="setAnswer"></MessageBox>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import ResponseAction from "@/views/ai/components/ResponseAction.vue";
import MessageBox from "@/views/ai/components/MessageBox.vue";
export default {
    data(){
        return {
            answers: [
                { code: 'Autopilot', message: 'Autopilot - Next-Gen' },
                { code: 'Manual', message: 'Crypto Racetrack - Legacy' }
            ],
        }
    },
    components: { ResponseAction, MessageBox },
    created(){

    },
    mounted(){

    },
    computed: {
        ...mapGetters(['tradingTypeAnswer']),
    },
    watch:{

    },
    methods: {
        setAnswer(data) {
            this.$emit('onSent', data);
        }
    }
}
</script>
<style scoped>

</style>